import Repository from '../../repositories/RepositoryFactory';
const inventoryConsumableCatalogs = Repository.get('inventoryConsumableCatalogs');

export default {
	namespaced: true,
	state: {
		consumableCatalogs: [],
		selectedConsumableCatalog: {},
		inventoryConsumableCategoryOptions: [],
		inventoryConsumableUnitOfMeasureOptions: [],
	},
	mutations: {
		SET_CONSUMABLE_CATALOGS (state, payload) {
			state.consumableCatalogs = payload;
		},
		SET_CONSUMABLE_CATALOG_UNIT_OF_MEASURE_OPTIONS (state, payload) {
			state.inventoryConsumableUnitOfMeasureOptions = payload;
		},
		SET_CONSUMABLE_CATALOG_CATEGORY_OPTIONS (state, payload) {
			state.inventoryConsumableCategoryOptions = payload;
		},
		SET_CONSUMABLE_CATALOG (state, payload) {
			state.selectedConsumableCatalog = payload;
		},
		DELETE_CONSUMABLE_CATALOG (state, id) {
			state.consumableCatalogs = state.consumableCatalogs.filter((catalog) => catalog.id !== id);
			if (state.selectedConsumableCatalog.id === id) {
				state.selectedConsumableCatalog = {};
			}
		},
	},
	actions: {
		async getConsumableCatalogs ({ commit }) {
			const result = await inventoryConsumableCatalogs.getConsumableCatalogs();
			commit('SET_CONSUMABLE_CATALOGS', result);
			return result;
		},
		async getConsumableCatalogById ({ commit }, id) {
			const result = await inventoryConsumableCatalogs.getConsumableCatalogById(id);
			commit('SET_CONSUMABLE_CATALOG', result);
		},
		async addConsumableCatalog ({ commit }, body) {
			const result = await inventoryConsumableCatalogs.addConsumableCatalog(body);
			return result;
		},
		async editConsumableCatalog ({ commit }, body) {
			return await inventoryConsumableCatalogs.editConsumableCatalog(body);
		},
		async deleteConsumableCatalogs ({ commit }, id) {
			const resultDelete = await inventoryConsumableCatalogs.deleteConsumableCatalogs(id);
			commit('DELETE_CONSUMABLE_CATALOG', id);
			return resultDelete;
		},
		async getInventoryConsumableCategoryOptions ({ commit }) {
			const result = await inventoryConsumableCatalogs.getInventoryConsumableCategoryOptions();
			commit(
				'SET_CONSUMABLE_CATALOG_CATEGORY_OPTIONS',
				result,
			);
			return result;
		},
		async getInventoryUnitOfMeasureOptions ({ commit }) {
			const result = await inventoryConsumableCatalogs.getInventoryUnitOfMeasureOptions();
			commit(
				'SET_CONSUMABLE_CATALOG_UNIT_OF_MEASURE_OPTIONS',
				result,
			);
			return result;
		},
	},
};
